<priva-loader [hasFooter]="true" class="update-app-loader">
    <priva-spinner />
    <ng-container data-footer>Updating app...</ng-container>
</priva-loader>
